'use client'

import { BuilderBlocks } from '@builder.io/react'
import { uniqueId } from 'lodash'
import Image from 'next/image'

import { type HeroLabelInputProps } from './HeroBanner.builder'

export const HeroLabels = ({
  logoLandscape,
  logoPortrait,
  textVariantLandscape = 'light',
  textVariantPortrait = 'light',
  builderBlock,
  ctaItems,
  headerItems,
}: HeroLabelInputProps) => {
  const textVariantLandscapeColor =
    textVariantLandscape === 'light' ? 'md:text-bodi-white' : 'md:text-bodi-black'
  const textVariantPortraitColor =
    textVariantPortrait === 'light' ? 'text-bodi-white' : 'text-bodi-black'
  return (
    <div className="z-10 flex w-full px-5 py-20 pb-16 md:max-w-xl md:px-16">
      <div className="flex w-full flex-col justify-center gap-6 pb-5">
        {(logoLandscape ?? logoPortrait) && (
          <>
            <Image
              className="lg:hidden"
              src={logoPortrait ?? logoLandscape ?? ''}
              alt="BODi Logo"
              width={191}
              height={37}
            />
            <Image
              className="hidden lg:block"
              src={logoPortrait ?? logoLandscape ?? ''}
              alt="BODi Logo"
              width={191}
              height={37}
            />
          </>
        )}

        {headerItems?.map((item, index: number) => {
          return (
            <BuilderBlocks
              key={uniqueId()}
              parentElementId={builderBlock?.id}
              className={`${textVariantLandscapeColor} ${textVariantPortraitColor} z-10`}
              dataPath={`component.options.headerItems.${index}.headerItem`}
              blocks={item.headerItem}
              // momentary fix for the text morth issue
              style={{ minHeight: 'auto !important' }}
            />
          )
        })}
        <div className="z-10 flex w-full flex-row gap-3 md:w-auto">
          {ctaItems?.map((item, index: number) => {
            return (
              <div key={uniqueId()} className="w-full md:w-auto">
                <BuilderBlocks
                  parentElementId={builderBlock?.id}
                  dataPath={`component.options.ctaItems.${index}.ctaItem`}
                  blocks={item.ctaItem}
                  style={{ minHeight: 'auto !important' }}
                  className="w-full md:w-auto"
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
